<div class="position-relative d-flex p-3 p-md-5 m-md-3 text-center bg-dark intro-banner">
  <div class="col-md-8 p-lg-5 mx-auto text-white align-self-center">
    <h1 class="display-5 font-weight-bold mx-auto">{{'Secteur pétrochimique' | translate}}</h1>
  </div>
</div>
<contact-us-btn></contact-us-btn>
<hr class="mb-5 mt-3">
<div class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Analyse du secteur de la pétrochimie' | translate}}</span>
    </div>
    <div class="container justif-center my-5">
      <p><span class="bold-blue">{{ 'La pétrochimie' | translate}}</span> {{ 'représente un secteur clé de l’industrie moderne et désigne la transformation d’une matière fossile : le pétrole. Ce secteur est faiblement féminisé et fait largement appel à la sous-traitance.' | translate}}</p>
    </div>
</div>
<div class="block-free-access py-5">
    <div class="container px-5">
        <div class="block p-0">
            <ul class="nav landing-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="global-tab" data-toggle="tab" href="#global" role="tab" aria-controls="global" aria-selected="true" title="World">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/world_icon.webp" type="image/webp">
                              <source srcset="/assets/world_icon.png" type="image/png">
            									<img src="/assets/world_icon.png" class="pays" alt="Global petrochemicals sector trends: Accidentology and Market Analysis" title="World" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'Global' | translate}}</b>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="usa-tab" data-toggle="tab" href="#usa" role="tab" aria-controls="usa" aria-selected="false" title="USA">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/usa_icon.webp" type="image/webp">
                              <source srcset="/assets/usa_icon.png" type="image/png">
            									<img src="/assets/usa_icon.png" class="pays" alt="United States petrochemicals sector trends: Accidentology and Market Analysis" title="USA" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'Etats-Unis' | translate}}</b>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="france-tab" data-toggle="tab" href="#france" role="tab" aria-controls="france" aria-selected="false" title="France">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/france_icon.webp" type="image/webp">
                              <source srcset="/assets/france_icon.png" type="image/png">
            									<img src="/assets/france_icon.png" class="pays" alt="French petrochemicals sector trends: Accidentology and Market Analysis" title="France" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'France' | translate}}</b>
                    </a>
                </li>
            </ul>
            <hr class="my-0">
            <div class="tab-content text-center py-4 px-3 px-md-5" id="myTabContent">
                <div class="tab-pane fade show active" id="global" role="tabpanel" aria-labelledby="global-tab">
                    <b class="sub-bar">{{'GLOBAL' | translate}}</b>
                    <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                    <ul class="mb-0 mt-2 text-justify">
                      <li>{{'Au cours de la période de 12 ans allant de 2003 à 2015, près de 480 décès ont été attribués aux transports.' | translate}} <a class="source" href="https://www.allinsgrp.com/blog/top-5-biggest-risks-facing-the-oil-and-gas-industry.aspx" target="_blank" rel="noopener nofollow" title="allinsgrp">{{'(source)' | translate}}</a></li>
                      <li>{{'Les blessures par contact représentent près de 26 % des décès (2003-2015).' | translate}} <a class="source" href="https://www.allinsgrp.com/blog/top-5-biggest-risks-facing-the-oil-and-gas-industry.aspx" target="_blank" rel="noopener nofollow" title="allinsgrp">{{'(source)' | translate}}</a></li>
                    </ul>
                    <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                    <ul class="mb-0 mt-2 text-justify">
                      <li>{{'L’Europe est le deuxième plus grand producteur de produits chimiques au monde et le deuxième plus grand investisseur en R&I au monde après la Chine (2020).' | translate}} <a class="source" href="https://www.francechimie.fr/media/52b/the-european-chemical-industry-facts-and-figures-2020.pdf" target="_blank" rel="noopener nofollow" title="francechimie">{{'(source)' | translate}}</a></li>
                    </ul>
                </div>
                <div class="tab-pane fade" id="usa" role="tabpanel" aria-labelledby="usa-tab">
                  <b class="sub-bar">{{'ETATS-UNIS' | translate}}</b>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'Une explosion de gaz naturel et de pétrole (2019) a entraîné la perte de 1,4 million de dollars de gaz naturel et de pétrole ' | translate}}<a class="source" href="https://www.kfyrtv.com/content/news/Witnesses-describe-explosion-at-Watford-City-saltwater-site-504522611.html" target="_blank" rel="noopener nofollow" title="kfyrtv">{{'(source)' | translate}}</a></li>
                    <li>{{'Cette industrie a un taux de mortalité d’environ 25 décès pour 100 000 travailleurs (2020) ' | translate}}<a class="source" href="https://goodmenproject.com/business-ethics-2/how-many-people-die-in-the-oil-and-gas-industry/" target="_blank" rel="noopener nofollow" title="goodmenproject">{{'(source)' | translate}}</a></li>
                  </ul>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'Rien qu’au Texas, les entreprises pétrolières et gazières ont vu leurs effectifs augmenter de 2 400 personnes en un an (2020) ' | translate}}<a class="source" href="https://goodmenproject.com/business-ethics-2/how-many-people-die-in-the-oil-and-gas-industry/" target="_blank" rel="noopener nofollow" title="goodmenproject">{{'(source)' | translate}}</a></li>
                  </ul>
                </div>
                <div class="tab-pane fade" id="france" role="tabpanel" aria-labelledby="france-tab">
                  <b class="sub-bar">{{'FRANCE' | translate}}</b>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'Les maladies spécifiques aux produits chimiques, tels que le benzène ou les dérivés d’hydrocarbures, constituent une cause majeure de congé maladie.' | translate}}</li>
                    <li>{{'74% des salariés bénéficient d’au moins une formation dans l’année (2019) ' | translate}}<a class="source" href="https://www.francechimie.fr/l-industrie-de-la-chimie#" target="_blank" rel="noopener nofollow" title="francechimie">{{'(source)' | translate}}</a></li>
                  </ul>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'La France compte 8 raffineries de pétrole fin 2019, dont 7 situées en métropole et une en Martinique ' | translate}}<a class="source" href="https://www.connaissancedesenergies.org/combien-y-t-il-de-raffineries-en-france-et-ou-sont-elles-situees-191219#:~:text=La%20France%20compte%208%20raffineries,m%C3%A9tropole%20et%20une%20en%20Martinique." target="_blank" rel="noopener nofollow" title="connaissancedesenergies">{{'(source)' | translate}}</a></li>
                  </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container my-5">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'Challenges du secteur' | translate}}</span>
    </div>
    <div class="row pt-2">
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/1-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'La digitalisation' | translate}}</p>
                <p class="text-justify">{{'L’intégration technologique à travers la chaîne de valeur devrait être un facteur majeur influençant la concurrence sur le marché. L’adoption de technologies telles que les drones, l’Internet des objets (IOT), la robotique, la blockchain, l’intelligence artificielle et le cloud computing devrait transformer la fabrication pétrochimique. Elle permettra d’améliorer le contrôle de la sécurité et d’améliorer la fiabilité et l’efficacité à travers la chaîne d’approvisionnement.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Campus collaboratif immersif digital & VR avec un catalogue d’exercices VR permettant une meilleure mémorisation des bonnes pratiques pour l’apprenant grâce à une approche ludique.' | translate}}
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/{{'gif-fr-competences-formations' | translate}}.webp" type="image/webp">
                <source srcset="assets/{{'gif-fr-competences-formations' | translate}}.gif" type="image/gif">
                <img src="assets/{{'gif-fr-competences-formations' | translate}}.gif" class="block-rounded" alt="An immersive virtual campus" title="Remote EHS events" loading="lazy">
            </picture>
        </div>
    </div>
    <hr class="px-2 mb-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/{{'pharma-proteger-accidents' | translate}}.webp" type="image/webp">
                <source srcset="assets/{{'pharma-proteger-accidents' | translate}}.png" type="image/png">
                <img src="assets/{{'pharma-proteger-accidents' | translate}}.png" class="block-rounded" alt="VR training workshops increase learner memory by 4" title="EHS VR trainings" loading="lazy">
            </picture>
        </div>
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/2-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Un taux d’accidents élevé' | translate}}</p>
                <p class="text-justify">{{'Le secteur est vaste et propice à une multitude d’accidents pour les employés, que ce soit en raison de la dangerosité des produits ou des conditions de travail difficiles.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'La plateforme numérique immersive & VR d’Immersive Factory vous permet d’organiser une multitude d’évènements HSE pour maintenir la culture de sécurité de votre entreprise. L’accès à notre catalogue de plus de 30 exercices d’apprentissage immersifs permet de plonger les apprenants dans des environnements variés, rendant l’apprentissage plus rapide et plus efficace que les formations traditionnelles pour réduire efficacement le nombre d’accidents.' | translate}}
                </div>
            </div>
        </div>
    </div>
    <hr class="px-2 my-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/3-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'La pluralité de sites et de risques' | translate}}</p>
                <p class="text-justify">{{'Difficulté du mode de formation pour le personnel et les équipes mobiles et difficulté de formations engageantes avec retours KPIs sur un outil unique. Dû à la multitude / diversité des intervenants sur la chaîne de valeurs (supply chain) (raffinerie, transport, distribution, etc.).' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Outil personnalisable permettant la cohérence des actions de chaque site sur un outil unique, et multi-device permettant à chaque apprenant de s’entraîner en sécurité, où qu’il se trouve. Le back office intuitif et l’accès des données en temps réel sur les indicateurs clés de performance (KPI) permet un suivi des efforts et des réalisations des équipes constant.' | translate}}
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 mb-md-4 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/Reporting_Moyenne_Horizontal_V2.webp" type="image/webp">
                <source srcset="assets/Reporting_Moyenne_Horizontal_V2.jpg" type="image/jpg">
                <img src="assets/Reporting_Moyenne_Horizontal_V2.jpg" class="block-rounded abstract-formation" alt="Website backoffice: reporting and statistics" title="Back-office" loading="lazy">
            </picture>
        </div>
    </div>
</div>
<hr class="my-4">
<div class="container my-5">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'Veillez à la sécurité de vos collaborateurs avec Immersive Factory' | translate}}</span>
    </div>
    <div class="text-justify">
    	<p>{{"Immersive Factory est une plateforme de formation en réalité virtuelle pour les entreprises dans le secteur de la pétrochimie qui allie sécurité et conformité aux nombreuses exigences et procédures nécessaires à la manipulation des produits chimiques." | translate}}</p>
    	<p>{{"Nos modules vous permettent d'améliorer la formation des travailleurs sur l'ensemble de leurs responsabilités variées. Notre outil de réalité virtuelle améliore l'aspect pédagogique des formations et est entièrement conçu sur mesure pour votre industrie grâce à une équipe de spécialistes et de techniciens formés au secteur de la pétrochimie. Nos sessions de formation concernent les journées sécurité et quarts d'heures sécurité, mais comprennent aussi des modules qui apprennent à votre personnel la manipulation des produits dangereux, des déchets et des différents outils à leur disposition." | translate }}</p>
    	<p class="mb-0">{{"Nous proposons des formations personnalisées à la manipulation des produits pétrochimiques dangereux à travers différents modules, outils, cours et pratiques adaptés pour aider vos équipes à améliorer la qualité de leur travail et à renforcer la sécurité des travailleurs." | translate }}</p>
    </div>
</div>
<hr *ngIf="blocnews" class="my-4">
<div *ngIf="blocnews" class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Envie d’en savoir plus sur les avantages des formations HSE en réalité virtuelle ?' | translate}}</span>
    </div>
    <div class="container my-5">
      <p class="justif-center">{{ 'Découvrez les sept avantages de la formation HSE en réalité virtuelle dans cet article de blog :' | translate}}</p>
      <div *ngIf="blocnews" class="mt-4">
        <div class="post row pr-0">
            <div class="col-12 col-md-6 mb-md-0 px-0">
                <a *ngIf="blocnews['link']" [routerLink]="language.navigateAccordingToLang([blocnews['link']])" target="blank" rel="noopener nofollow" title="{{blocnews['title']}}"><img src='{{blocnews.imageHeader}}' class="news-image abstract-formation" alt="7 benefits of Virtual reality EHS training" title="VR EHS trainings" loading="lazy"></a>
            </div>
            <div class="col-12 col-md-6 px-4 pt-4 mb-4 d-flex justify-content-center align-items-center">
                <div>
                    <p *ngIf="blocnews['title']" class="font-weight-bold ifsolution">{{blocnews["title"]}}</p>
                    <div class="informations my-3">
                        <span *ngIf="blocnews['createdDate']" class="date">{{blocnews["createdDate"]}}</span>
                        <div *ngIf="blocnews.tag['title']" class="tag rounded px-2">{{blocnews.tag["title"]}}</div>
                    </div>
                    <div class="actu-body">
                      <p *ngIf="blocnews['shortDesc']" class="description" [innerHTML]="blocnews['shortDesc']"></p>
                      <a *ngIf="blocnews['link']" [routerLink]="language.navigateAccordingToLang([blocnews['link']])" class="viewmore mb-3" target="blank" rel="noopener nofollow" title="{{blocnews['title']}}">{{'Voir plus' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
</div>


<hr class="mt-5">
<div class="reassurance">
    <div class="container py-4 mb-4">
        <h3 class="my-4">{{ 'Ils nous font confiance' | translate}}</h3>
        <owl-carousel
            [options]="{
                items: 5,
                dots: false,
                nav: true,
                margin:0,
                loop:true,
                autoplay:true,
                autoplayTimeout:3000,
                autoplayHoverPause:true,
                responsive:{
                    '300':{
                        items:1,
                        nav:true
                    },
                    '768':{
                        items:3,
                        nav:true
                    },
                    '992':{
                        items:5,
                        nav:true,
                        loop:true
                    }
                }
            }"
            [carouselClasses]="['owl-carousel']">
            <div class="logos-theytrustus" *ngFor="let image of images;let i = index">
                <picture>
                    <source srcset="{{image.url}}.webp" type="image/webp">
                    <source srcset="{{image.url}}.png" type="image/png">
                    <img src="{{image.url}}.png" [attr.alt]="image.alt" [attr.title]="image.title" loading="lazy">
                </picture>
            </div>
        </owl-carousel>
    </div>
</div>
<hr class="my-4">


<div class="container mb-5">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'exercices dédiés au secteur pétrochimique' | translate}}</span>
    </div>
    <div *ngIf="listProducts" class="mt-4">
        <div class="row ml-0 mr-0">
          <app-product-card class="col-md-4 mt-4"  *ngFor="let product of listProducts" [product]="product"></app-product-card>
        </div>
    </div>
</div>
<!-- TEMOIGNAGE CLIENT
<hr class="my-4">
<div class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Témoignage client' | translate}}</span>
    </div>

    <div class="container-fluid mb-5">
        <div class="row">
            <div class="col-md-6 col-12 latest-pub">
                <h2 class="title-pub bold px-4 pt-2">{{'Téléchargez notre dernier témoignage client' | translate}}</h2>
                <h3 class="text-pub mt-2 px-4">{{'Témoignage Lorem Ipsum' | translate}}</h3>
                <a href="https://communication.immersivefactory.com/{{'FR_Analyse_Critique_Modeles_Apprentissage.pdf' | translate}}" target="_blank">
                <div class="download-btn mt-4">
                    <i class="fas fa-download"></i><span class="ml-2">{{'Télécharger' | translate}}</span>
                </div>
                </a>
            </div>
            <div class="col-md-6 col-12 book">
                <div class="magasine magasine-{{language.lang}}">
                </div>
            </div>
        </div>
    </div>
</div>
-->
